import React from "react"

const FlexContentFull = props => (
  <div className="flex-content__part flex-content__part--full">
    <article dangerouslySetInnerHTML={{ __html: props.content }} />
  </div>
)

export default FlexContentFull
